export const SurveyOptionsMap = {
  async mounted() {
    this.markers = new Map()
    await this.renderMap()
    this.setupHighlightListeners()
  },

  async renderMap() {
    const properties = JSON.parse(this.el.dataset.properties || "[]")
    const fallbackCenter = JSON.parse(this.el.dataset.center || "{}")

    await window.Enaia.loadGoogleMaps()

    const center =
      properties.length > 0
        ? {
            lat: parseFloat(properties[0].lat),
            lng: parseFloat(properties[0].lng),
          }
        : {
            lat: parseFloat(fallbackCenter.lat || "39.8283"),
            lng: parseFloat(fallbackCenter.lng || "-98.5795"),
          }
    const initialZoom =
      properties.length > 0 ? 12 : parseInt(fallbackCenter.zoom || "4", 10)

    const map = new google.maps.Map(this.el, {
      zoom: initialZoom,
      minZoom: 3,
      backgroundColor: "#e8eef1",
      center,
      styles: window.Enaia.GoogleMapsStyles.DESATURATED_MAP_STYLES,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
      fullscreenControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP,
      },
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER,
      },
    })

    const bounds = new google.maps.LatLngBounds()
    const hook = this

    properties.forEach((property) => {
      const position = {
        lat: parseFloat(property.lat),
        lng: parseFloat(property.lng),
      }
      bounds.extend(position)

      const markerColor =
        property.wants_tour === true
          ? "#10b981"
          : property.wants_tour === false
            ? "#ef4444"
            : "#0086e6"

      const defaultIcon = {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 10,
        fillColor: markerColor,
        fillOpacity: 0.9,
        strokeColor: "#ffffff",
        strokeWeight: 2,
      }
      const highlightedIcon = {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 14,
        fillColor: markerColor,
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 3,
      }
      const dimmedIcon = {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 10,
        fillColor: markerColor,
        fillOpacity: 0.3,
        strokeColor: "#ffffff",
        strokeWeight: 2,
      }

      const marker = new google.maps.Marker({
        position,
        map,
        icon: defaultIcon,
        title: property.address,
      })

      hook.markers.set(property.id, {
        marker,
        defaultIcon,
        highlightedIcon,
        dimmedIcon,
      })

      marker.addListener("mouseover", () => {
        hook.highlightMarker(property.id)
        window.dispatchEvent(
          new CustomEvent("survey-modal:highlight-card", {
            detail: { optionId: property.id },
          }),
        )
      })
      marker.addListener("mouseout", () => {
        hook.resetAllMarkers()
        window.dispatchEvent(
          new CustomEvent("survey-modal:unhighlight-card", {
            detail: { optionId: property.id },
          }),
        )
      })
    })

    if (properties.length > 1) {
      map.fitBounds(bounds)
      const listener = google.maps.event.addListener(map, "idle", () => {
        if (map.getZoom() > 15) map.setZoom(15)
        google.maps.event.removeListener(listener)
      })
    }
  },

  highlightMarker(id) {
    this.markers.forEach((data, markerId) => {
      if (markerId === id) {
        data.marker.setIcon(data.highlightedIcon)
        data.marker.setZIndex(1000)
      } else {
        data.marker.setIcon(data.dimmedIcon)
        data.marker.setZIndex(1)
      }
    })
  },

  resetAllMarkers() {
    this.markers.forEach((data) => {
      data.marker.setIcon(data.defaultIcon)
      data.marker.setZIndex(1)
    })
  },

  setupHighlightListeners() {
    const hook = this
    this.highlightHandler = (e) => hook.highlightMarker(e.detail.optionId)
    this.unhighlightHandler = () => hook.resetAllMarkers()
    window.addEventListener("survey-modal-map:highlight", this.highlightHandler)
    window.addEventListener(
      "survey-modal-map:unhighlight",
      this.unhighlightHandler,
    )
  },

  destroyed() {
    if (this.highlightHandler) {
      window.removeEventListener(
        "survey-modal-map:highlight",
        this.highlightHandler,
      )
    }
    if (this.unhighlightHandler) {
      window.removeEventListener(
        "survey-modal-map:unhighlight",
        this.unhighlightHandler,
      )
    }
  },
}
